import { Injectable } from '@angular/core';
import { Estado } from '@tivic-team/manager-ts/dist/grl';
import { EstadoController } from 'app/controllers/grl/estado.controller';
import { LoaderService } from '../loader.service';
import { ApiService } from './../api-service.interface';
import { EstadoSearch } from './estado.search';

@Injectable()
export class EstadoService implements ApiService<Estado>{

    constructor(
        private _estadoController: EstadoController,
        private _loaderService: LoaderService
    ) {}

    find(search?: EstadoSearch): Promise<Estado[]> {
        this._loaderService.show();
        return this._estadoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    findEstados(search?: EstadoSearch): Promise<Estado[]> {
        this._loaderService.show();
        return this._estadoController.findEstados(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<Estado> {
        this._loaderService.show();
        return this._estadoController.get(id).finally(() => this._loaderService.hide());
    }

    create(entity: Estado): Promise<Estado> {
        this._loaderService.show();
        return this._estadoController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: Estado): Promise<Estado> {
        this._loaderService.show();
        return this._estadoController.update(entity).finally(() => this._loaderService.hide());
    }

    save(estado: Estado): Promise<Estado> {
        this._loaderService.show();

        if (estado.cdEstado && estado.cdEstado > 0) {
            return this._estadoController.update(estado).finally(() => this._loaderService.hide());
        } else {
            return this._estadoController.create(estado).finally(() => this._loaderService.hide());
        }
    }
}